import React from 'react';
import { Container, Box, Typography, Alert } from '@mui/material';
import { DjangoCSRFToken } from "/@/app/utils";
import { Button, Grid } from '@mui/material';
//
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout';
//
import { TesterViewMenu } from '/@/app/views/TesterView/TesterViewMenu';
import { InstallComponent } from '/@/app/PWA/InstallComponent';

export const Actions = () => {
    return (
        <HelpingDrawerLayout
            drawerContent={TesterViewMenu}
            buttonText="Разделы"
            // customized smaller sidebar
            sidebarWidth={{xs: "0", lg: "300px"}}
            drawerWidth={{xs: "100vw", sm: "300px"}}
        >
            <Container maxWidth="sm">
                <Box sx={{
                    pr: {xs: 2, sm: 0},
                    pb: 10,  // keep bottom space for floating bottom panels
                }}>
                    <Typography variant="h2" gutterBottom>Отладочные действия</Typography>
                    <Alert severity="warning">Осторожно! Эти действия могут удалять данные текущего пользователя</Alert>
                    <Grid container spacing={3} sx={{textAlign: "center", p: 2}}>
                        <Grid item xs={12}>
                            <form action="/cabinet/debug/panel/clear/" method="post">
                                <DjangoCSRFToken />
                                <Button type="submit" variant="contained">Удалить все данные из текущей панели</Button>
                            </form>
                        </Grid>
                        <Grid item xs={12}>
                            <form action="/cabinet/debug/panel/fill/" method="post">
                                <DjangoCSRFToken />
                                <Button type="submit" variant="contained">Загрузить Демо Панель в текущую</Button>
                            </form>
                        </Grid>
                        <Grid item xs={12}>
                            Динамика:
                        </Grid>
                        <Grid item xs={12}>
                            <form action="/cabinet/debug/panels/reset/" method="post">
                                <DjangoCSRFToken />
                                <input type="hidden" name="set-name" value="SET_ONE" />
                                <Button type="submit" variant="contained">Загрузить набор панелей `SET_ONE`</Button>
                            </form>
                        </Grid>
                    </Grid>

                    <Typography variant="h2" sx={{ mt: 5 }} gutterBottom>PWA Status</Typography>
                    <Typography variant="body1" gutterBottom>
                        Статус установки Progressive Web Application.
                        Кнопка установки также отобразится здесь, если установка возможна.
                    </Typography>
                    <InstallComponent showDebug={true} />
                </Box>
            </Container>
        </HelpingDrawerLayout>
    );
}
